import React from 'react';
import MkIcon from '../MkIcon';

const STEPS = [
  {
    icon: 'apps-check',
    title: 'Choose your apps',
    body: 'Pick the apps that pull you in: up to 3 for free, unlimited with Premium.',
  },
  {
    icon: 'hand',
    title: 'Open one',
    body: 'Bring Me Back steps in with a short pause before the app takes over.',
  },
  {
    icon: 'breath',
    title: 'Then decide',
    body: 'Breathe, then continue to the app or step away. Your choice, every time.',
  },
];

// B2 — how a pause works (same layout as the Home steps, in teal).
const BmbHow = () => (
  <section className="mk-how mk-how--bmb section" id="how" aria-labelledby="mk-bmbhow-title">
    <div className="container-sm">
      <div className="section-inner">
        <div className="mk-head reveal-from-bottom">
          <h2 id="mk-bmbhow-title" className="mk-h2">
            How a pause works
          </h2>
        </div>
        <ol className="list-reset mk-steps">
          {STEPS.map((s, i) => (
            <li
              key={s.title}
              className="mk-steps__item reveal-from-bottom"
              data-reveal-container=".mk-steps"
              data-reveal-delay={i * 120}
            >
              <div className="mk-card mk-step">
                <span className="mk-step__num" aria-hidden="true">
                  {i + 1}
                </span>
                <span className="mk-icon-tile mk-icon-tile--bmb">
                  <MkIcon name={s.icon} />
                </span>
                <h3 className="mk-h3">{s.title}</h3>
                <p className="mk-body">{s.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default BmbHow;
